"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Datepicker = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _DatepickerComponent = require("./components/DateSelector/DatepickerComponent.js");
var _themeProvider = require("../../../theme/themeProvider/index.js");
var _DateSelector = _interopRequireDefault(require("./components/DateSelector/index.js"));
var _MonthSelector = require("./components/MonthSelector/MonthSelector.js");
var _YearSelector = _interopRequireDefault(require("./components/YearSelector/index.js"));
var _interface = require("./interface.js");
var _utils = require("./utils.js");
var _StyledComponent = require("./components/StyledComponent.js");
require("./datepicker.css");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["monthNames", "weekdayNames", "bg", "borderRadius", "padding", "prevMonthButtonView", "nextMonthButtonView", "monthYearColor", "weekdaysColor", "daysColor", "disabledDaysColor", "monthOffset", "minDate", "maxDate", "daySelectedBg", "daySelectedColor", "selectedDate", "selectedDates", "disabledDates", "startYear", "startDate", "endDate", "mode", "onDateChange", "onChangeDatesHande", "onChangeStartEndDateHandle", "dayRangeBg", "dayRangeColor", "ClassName", "styledDatePickerClass", "handleClose", "isCurrentStartDate", "zindexValue", "onLoadShowCalender", "hoverDateBgColor", "currentDateBorderColor", "currentDateTextColor", "dateRangeBgColor", "onHoverDateRangeBgColor", "calenderAlignment", "datePickerPosition"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Datepicker = props => {
  const theme = (0, _themeProvider.useTheme)();
  const {
      monthNames = _utils.months,
      weekdayNames = _utils.weekdays,
      bg = theme.color.background,
      borderRadius = theme.variables.borderRadius,
      padding = '32px',
      prevMonthButtonView,
      nextMonthButtonView,
      monthYearColor = theme.color.defaultTextColor,
      weekdaysColor = theme.color.defaultTextColor,
      daysColor = theme.color.defaultTextColor,
      disabledDaysColor = theme.color.defaultLabelColor,
      monthOffset = 0,
      minDate,
      maxDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      daySelectedBg = '#18BA92',
      daySelectedColor = theme.color.primaryBgColor,
      selectedDate,
      selectedDates,
      startYear,
      startDate = new Date(),
      endDate,
      mode = 'date',
      onDateChange,
      onChangeDatesHande,
      onChangeStartEndDateHandle,
      dayRangeBg = theme.color.primary,
      dayRangeColor = theme.color.neutral200,
      ClassName,
      styledDatePickerClass,
      handleClose,
      isCurrentStartDate = false,
      zindexValue = "2",
      onLoadShowCalender = false,
      hoverDateBgColor = theme.color.primary,
      // hoverDateTextColor = theme.color.primaryBgColor,
      currentDateBorderColor = theme.color.primary,
      currentDateTextColor = theme.color.primaryBgColor,
      dateRangeBgColor = theme.color.primary,
      onHoverDateRangeBgColor = theme.color.primary,
      calenderAlignment,
      datePickerPosition
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const updatedStartDate = isCurrentStartDate ? props.startDate : startDate;
  const [updatedStartDateValue, setUpdatedStartDate] = (0, _react.useState)(updatedStartDate);
  const initialDate = minDate || new Date(`01-01-${startYear}`) || _utils.defaultStartDate;
  (0, _react.useEffect)(() => {
    setUpdatedStartDate(updatedStartDateValue);
  }, [updatedStartDateValue]);
  const [endDateValue, setEndDate] = (0, _react.useState)(endDate);
  (0, _react.useEffect)(() => {
    setEndDate(endDate);
  }, [endDate]);
  const [currentSelector, setCurrentSelector] = (0, _react.useState)(_interface.DatePickerSelectorEnum.DATE);
  const [currentYearMonth, setCurrentYearMonth] = (0, _react.useState)(updatedStartDateValue ? new Date(updatedStartDateValue.getFullYear(), updatedStartDateValue.getMonth() + monthOffset, updatedStartDateValue.getDate()) : new Date());
  const handleCurrentYearMonth = date => {
    setCurrentYearMonth(date);
  };
  const datePickerStyle = ['datepicker__component', ClassName].join(' ');
  const setShowDateSelector = () => {
    setCurrentSelector(_interface.DatePickerSelectorEnum.DATE);
  };
  const handleDateChange = e => {
    onDateChange && onDateChange(e);
    handleClose && handleClose();
  };
  const getSelectorComponent = () => {
    switch (currentSelector) {
      case _interface.DatePickerSelectorEnum.MONTH:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MonthSelector.DatePickerMonthSelector, Object.assign({
          textColor: daysColor,
          selectedColor: daySelectedColor,
          selectedBg: daySelectedBg,
          setShowDateSelector: setShowDateSelector,
          setCurrentYearMonth: setCurrentYearMonth,
          currentYearMonth: currentYearMonth,
          disabledDaysColor: disabledDaysColor,
          maxDate: maxDate,
          borderRadius: `${borderRadius}px`
        }, rest));
      case _interface.DatePickerSelectorEnum.YEAR:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_YearSelector.default, Object.assign({
          textColor: daysColor,
          selectedColor: daySelectedColor,
          selectedBg: daySelectedBg,
          setShowDateSelector: setShowDateSelector,
          setCurrentYearMonth: setCurrentYearMonth,
          currentYearMonth: currentYearMonth,
          disabledDaysColor: disabledDaysColor,
          maxDate: maxDate,
          minDate: minDate,
          borderRadius: borderRadius,
          startYear: startYear
        }, rest));
      default:
        break;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateSelector.default, Object.assign({
      prevMonthButtonView: prevMonthButtonView,
      monthYearColor: monthYearColor,
      monthNames: monthNames,
      nextMonthButtonView: nextMonthButtonView,
      weekdayNames: weekdayNames,
      weekdaysColor: weekdaysColor,
      daysColor: daysColor,
      disabledDaysColor: disabledDaysColor,
      mode: mode,
      selectedDate: selectedDate,
      onDateChange: handleDateChange,
      onChangeDatesHande: onChangeDatesHande,
      onChangeStartEndDateHandle: onChangeStartEndDateHandle,
      maxDate: maxDate,
      minDate: initialDate,
      startDate: updatedStartDateValue,
      selectedDates: selectedDates,
      monthOffset: monthOffset,
      endDate: endDateValue,
      currentYearMonth: currentYearMonth,
      setCurrentSelector: setCurrentSelector,
      setCurrentYearMonth: handleCurrentYearMonth,
      borderRadius: borderRadius
    }, rest));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledDatePickerContainer, {
    className: styledDatePickerClass,
    calenderAlignment: calenderAlignment,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatepickerComponent.DatepickerComponent, Object.assign({
      width: "auto",
      bg: bg,
      borderRadius: borderRadius,
      padding: padding,
      spacing: "16px",
      daySelectedBg: daySelectedBg,
      daySelectedColor: daySelectedColor,
      dayRangeBg: dayRangeBg,
      dayRangeColor: dayRangeColor,
      className: datePickerStyle,
      zindexValue: zindexValue,
      hoverDateBgColor: hoverDateBgColor,
      currentDateBorderColor: currentDateBorderColor,
      currentDateTextColor: currentDateTextColor,
      onHoverDateRangeBgColor: onHoverDateRangeBgColor,
      onLoadShowCalender: onLoadShowCalender,
      datePickerPosition: datePickerPosition,
      calenderAlignment: calenderAlignment
    }, rest, {
      children: getSelectorComponent()
    }))
  });
};
exports.Datepicker = Datepicker;
var _default = exports.default = Datepicker;